/**
 * Quick Capture не пытается «угадать» тип мысли. Ошибка классификации хуже
 * лишнего нажатия: ожидание, превращённое в задачу, снова окажется у человека
 * в голове. Поэтому тип выбирается явно, а здесь остаётся одна проверяемая
 * функция, которая готовит ровно тот payload, который ждёт существующий API.
 */
export type QuickCaptureKind = 'task' | 'waiting' | 'decision' | 'note';

export interface QuickCaptureDraft {
  title: string;
  projectId: string;
  dueDate: string;
  waitingFor: string;
  followUpDate: string;
}

export type QuickCapturePayload =
  | {
      kind: 'task';
      body: { project_id: string; title: string; due_date: string | null };
    }
  | {
      kind: 'waiting';
      body: { title: string; waiting_for: string; follow_up_date: string | null };
    }
  | { kind: 'decision'; body: { title: string } }
  | { kind: 'note'; body: { title: string } };

/**
 * Возвращает null, если capture нельзя сохранить без придумывания данных.
 * У ожидания обязательны и предмет, и тот, от кого ждём; всё остальное
 * умеют принять соответствующие существующие маршруты без новой схемы БД.
 */
export function buildQuickCapture(
  kind: QuickCaptureKind,
  draft: QuickCaptureDraft,
): QuickCapturePayload | null {
  const title = draft.title.trim();
  if (!title) return null;

  switch (kind) {
    case 'task':
      if (!draft.projectId) return null;
      return {
        kind,
        body: { project_id: draft.projectId, title, due_date: draft.dueDate || null },
      };
    case 'waiting': {
      const waitingFor = draft.waitingFor.trim();
      if (!waitingFor) return null;
      return {
        kind,
        body: { title, waiting_for: waitingFor, follow_up_date: draft.followUpDate || null },
      };
    }
    case 'decision':
    case 'note':
      return { kind, body: { title } };
  }
}
